module.exports = __webpack_public_path__ + "static/media/TanviSharma3.876ff79d.png";